import { render, staticRenderFns } from "./catalog-svg-icons.vue?vue&type=template&id=4f929d9d&scoped=true"
import script from "./catalog-svg-icons.vue?vue&type=script&lang=js"
export * from "./catalog-svg-icons.vue?vue&type=script&lang=js"
import style0 from "./catalog-svg-icons.vue?vue&type=style&index=0&id=4f929d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f929d9d",
  null
  
)

export default component.exports